import { Observable } from 'rxjs';
import 'rxjs/add/operator/debounceTime';
import get from 'lodash/get';

import { WINDOW_AVAILABLE } from '../redux/app';
import { browserResized } from '../redux/env';

import type { ActionObs, Store, Obs } from '../types';

export default function browserSizingEpic(
  action$: ActionObs,
  store: Store,
): Obs {
  return action$.ofType(WINDOW_AVAILABLE).mergeMap(() => {
    return Observable.fromEvent(window, 'resize')
      .map(() => {
        return {
          width: get(window, 'document.documentElement.clientWidth'),
        };
      })
      .debounceTime(200)
      .map(dimensions => browserResized(dimensions));
  });
}
